import React, { useState, useEffect } from "react";
import { Typography, Grid, Button, FormControl, OutlinedInput, Card } from "@mui/material"
import SelectImage from "../../../static/images/salesOrder/Enter OTP-pana.svg"
import theme, {
    textClasses,
    cardClasses,
    inputClasses,
    buttonClasses,
} from "../../../static/styles/theme";
import { selectStylesOverride } from "../../../utils/util";
import { getPassLinkValidationToken } from "../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../../services/functions";
import history from "../../../services/history";
 

const PasscodeValidation = () => {
  const dispatch = useDispatch();

  const [passLink, setPassLink] = useState({
    passcode: "",
    linkURL: window.location.href,
  });

  const handleSubmit = () => {
    let payload = {
      passcode: passLink?.passcode || "",
      link: passLink?.linkURL || "",
      accessFor: "salesOrder",
    };
    dispatch(
      getPassLinkValidationToken(payload, (data = {}) => {
        showToast(data?.message, !data.success);
        if (data?.success) {
          localStorage.setItem("passToken", JSON.stringify(data?.data));
          history.push(`/saveEFormDetail?passcode=${passLink?.passcode}`);
        }
      })
    );
  };

  const handleClear = () => {
    setPassLink({ ...passLink, passcode: "" });
  };

  useEffect(() => {
    localStorage.removeItem("passToken");
    localStorage.removeItem("e-slotsBooked");
  }, []);

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      height="100vh"
      sx={{ backgroundColor: "#F77200", px: { xs: 2, sm: 4 } }}
    >
      <Card
        sx={{
          p: { xs: 2, sm: 3 },
          minWidth: { xs: "90vw", sm: "64vw" }, // ✅ shrink on mobile
          minHeight: { xs: "auto", sm: "20vh" }, // auto height on small screens
          borderRadius: "12px",
        }}
      >
        {/* Title */}
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
          <Typography
            sx={{
              ...textClasses.cardTitle,
              fontSize: { xs: "18px", sm: "22px" }, // smaller on mobile
              textAlign: "center",
            }}
          >
            Enter Passcode
          </Typography>
        </Grid>

        {/* Image */}
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", my: 2 }}>
          <img
            src={SelectImage}
            alt="Passcode Illustration"
            style={{
              width: "100%",
              maxWidth: "450px",
              height: "auto", // responsive image
            }}
          />
        </Grid>

        {/* Instructions */}
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
          <Typography
            sx={{
              ...textClasses.t16n,
              textAlign: "center",
              mt: 1,
              fontWeight: "600",
              fontSize: { xs: "14px", sm: "16px" },
              px: { xs: 1, sm: 0 },
            }}
          >
            Please enter passcode shared along with this link
            to fill the sales order form.
          </Typography>
        </Grid>

        {/* Input */}
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <FormControl sx={{ width: { xs: "100%", sm: "308px" } }}>
            <OutlinedInput
              value={passLink?.passcode}
              onChange={(e) => setPassLink({ ...passLink, passcode: e.target.value })}
              sx={{
                ...inputClasses.textField,
                height: "40px",
              }}
            />
          </FormControl>
        </Grid>

        {/* Buttons */}
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" }, // stack on mobile
            justifyContent: { xs: "center", sm: "flex-start" },
            alignItems: "center",
            mt: 3,
            gap: { xs: 2, sm: 0 },
          }}
        >
          <Button
            variant="outlined"
            size="medium"
            data-testid="clear-passcode-btn"
            sx={{
              ...buttonClasses.lynkitBlackEmpty,
              width: { xs: "100%", sm: 150 },
            }}
            onClick={handleClear}
          >
            Clear
          </Button>

          <Button
            variant="contained"
            size="medium"
            data-testid="submit-passcode-btn"
            sx={{
              ...buttonClasses.lynkitOrangeFill,
              width: { xs: "100%", sm: 150 },
              ml: { xs: 0, sm: 2 },
            }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </Grid>
      </Card>
    </Grid>
  );
};

export default PasscodeValidation;